import React from 'react';
import styled from 'styled-components';

import background from '../assets/images/header-background2.jpg';

const StyledComponent = styled.div`
 .social-links-nav{
    display: flex;
    padding: 0px;
    margin: 0px;
    list-style: none;
    & li a{
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        padding: 8px 8px;
        width: 45px;
        height: 45px;
        background: transparent;
        -webkit-transform: skew(-20deg);
        -moz-transform: skew(-20deg);
        -ms-transform: skew(-20deg);
        -o-transform: skew(-20deg);
        transform: skew(-20deg);
        transition: all 0.3s ease;
        background-color: var(--color-rojo);
        transition: all .5s ease;
        & img{
            filter: invert(97%) sepia(39%) saturate(0%) hue-rotate(130deg) brightness(110%) contrast(100%);
            //filter: invert(77%) sepia(12%) saturate(233%) hue-rotate(192deg) brightness(99%) contrast(80%);
            -webkit-transform: skew(20deg);
            -moz-transform: skew(20deg);
            -ms-transform: skew(20deg);
            -o-transform: skew(20deg);
            transform: skew(20deg);
            transition: all 1s ease;
        }
        &:hover{
            background-color: var(--color-azul);
            & img{
                filter: invert(97%) sepia(39%) saturate(0%) hue-rotate(130deg) brightness(110%) contrast(100%);
            }
        }
        
    }

}

.sticky-logo{
    background-color: var(--color-rojo);
    padding: 12px 15px;
    margin-left: -30px;
    padding-left: 60px;
    padding-right: 60px;
    position: absolute;
    -webkit-transform: skew(-30deg);
    transform: skew(-30deg);
    top: 0px;
    left: -20px;
        @media (max-width: 1250px) {
            padding: 25px 40px;
            margin-left: -10px;
        }
        @media (max-width: 1230px) {
          padding: 7px 40px;
        }
        @media (max-width: 730px) {
          -webkit-transform: skew(0deg);
          transform: skew(0deg);
          width: 100%;
          margin-left: 0px;
          left: 0px;
        }
    & a{
        -webkit-transform: skew(30deg);
        -moz-transform: skew(30deg);
        -ms-transform: skew(30deg);
        -o-transform: skew(30deg);
        transform: skew(30deg);
        display: flex;
        align-items: center;
        justify-content:center;
        color:#ffffff;
        font-weight: 400;
        font-size: 2.4rem;
        margin-right: 0px;
        @media (max-width: 730px) {
          -webkit-transform: skew(0deg);
          transform: skew(0deg);
        }
        & img{
            margin-right:15px;
            max-width: 70px;
        }
        @media (max-width: 1250px) {
            font-size: 1.5rem;
            & img{
                max-width: 50px;
            }
        }
    }
}

.fila-1, .fila-2{
    @media (max-width: 1920px) {
        .container{
            max-width: 100%;
        }
    }
}

.fila-1{display: inline-block;width:100%;background-color:transparent;
  padding:0px 15px;
  @media (max-width: 730px) {
    display:none;
  }
}
.fila-2{display: inline-block;width:100%;background-color:transparent;}

.nav-flex{
    display: flex;
    width:100%;
    justify-content: space-between;
    padding-left: 10%;
    transition: all 0.3s ease;
    @media (max-width: 1920px) {
        padding-left: 25%;
      }
     @media (max-width: 1850px) {
        padding-left: 28%;
      }
      @media (max-width: 1750px) {
        padding-left: 30%;
      }
      @media (max-width: 1650px) {
        padding-left: 32%;
      }
      @media (max-width: 1550px) {
        padding-left: 32%;
      }
      @media (max-width: 1450px) {
        padding-left: 35%;
      }

      @media (max-width: 1350px) {
        padding-left: 38%;
      }

      @media (max-width: 1250px) {
        padding-left: 25%;
      }

      @media (max-width: 1200px) {
        padding-left: 30%;
      }
      
    & li{
        & a{
            color:#ffffff;
            text-transform: uppercase;
            letter-spacing: 1px;
            @media (max-width: 1200px) {
                letter-spacing: .5px;
              }
        }
    }
}

.navbar-nav{

  @media (max-width: 730px) {
        display:none;
      }

    .dropdown-menu{
        background-color: rgba(#363533,1);
        border-radius: 0px;
        border-top: 2px solid var(--color-rojo);
        & .dropdown-item:focus, & .dropdown-item:hover {
            color: var(--color-rojo);
            text-decoration: none;
            background-color: transparent;
            border-bottom: 1px solid var(--color-rojo);
        }

    }

}


`
interface props{
  title:string
}

export default  (props:props) => (
    <StyledComponent>
        <header className="fixed-top">
 
 <div className="fila-1">
   
     <div className="d-flex justify-content-end">
       <ul className="social-links-nav">
         <li><a href="https://www.facebook.com/AtletideSanLuis" target="_blank"><img src="https://atleticodesanluis.mx/img/footer/redes/facebook.png" alt="Facebook" /></a></li>
         <li><a href="https://www.instagram.com/atletidesanluis/" target="_blank"><img src="https://atleticodesanluis.mx/img/footer/redes/instagram.png" alt="Instagram" /></a></li>
         <li><a href="https://twitter.com/AtletideSanLuis" target="_blank"><img src="https://atleticodesanluis.mx/img/footer/redes/twitter.png" alt="Twitter" /></a></li>	
         <li><a href="https://vm.tiktok.com/ZMLhykVNU/" target="_blank"><img src="https://atleticodesanluis.mx//img/footer/redes/tik-tok.png" alt="TicTok" /></a></li>
         <li><a href="https://www.youtube.com/channel/UCF-kaaSSk9rBEHa9MsfsGjA" target="_blank"><img src="https://atleticodesanluis.mx/img/footer/redes/youtube.png" alt="Youtube" /></a></li>
       </ul>
     </div>
   
 </div>
 <div className="fila-2">
      <div className="sticky-logo"><a className="navbar-brand" href="https://atleticodesanluis.mx/">
        <img className="img-fluid" src="https://atleticodesanluis.mx/img/home/logo.png" />ATLÉTICO DE SAN LUIS</a>
      </div>
      <nav className="navbar  navbar-expand-lg pl-0 pr-0">
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
       <div className="hidden" id="navbarSupportedContent">
         <ul className="navbar-nav nav-flex">
           <li className="nav-item dropdown">
             <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
               Club
             </a>
             <div className="dropdown-menu" aria-labelledby="navbarDropdown">
               <a className="dropdown-item" href="https://atleticodesanluis.mx/contenidos/ownership">Ownership</a>
               <a className="dropdown-item" href="https://atleticodesanluis.mx/contenidos/directiva">Directiva/Leadership Group</a>
               <a className="dropdown-item" href="https://atleticodesanluis.mx/contenidos/valores">Nuestros valores</a>
               <a className="dropdown-item" href="https://atleticodesanluis.mx/contenidos/socios-comerciales">Socios Comerciales</a>
               <a className="dropdown-item" href="https://atleticodesanluis.mx/estadio">Estadio Alfonso Lastras</a>
               <a className="dropdown-item" href="https://atleticodesanluis.mx/contenidos/prensa">PRENSA</a>
             </div>
           </li>

           <li className="nav-item dropdown">
             <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
               Noticias
             </a>
             <div className="dropdown-menu" aria-labelledby="navbarDropdown">
               <a className="dropdown-item" href="https://atleticodesanluis.mx/noticias/tag/primer-equipo">Primer Equipo</a>
               <a className="dropdown-item" href="https://atleticodesanluis.mx/noticias/tag/femenil">Femenil</a>
               <a className="dropdown-item" href="https://atleticodesanluis.mx/noticias/tag/juveniles">Juveniles</a>
               <a className="dropdown-item" href="https://atleticodesanluis.mx/videos">Videos</a>
             </div>
           </li>

           <li className="nav-item dropdown">
             <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
               Primer equipo
             </a>
             <div className="dropdown-menu" aria-labelledby="navbarDropdown">
               <a className="dropdown-item" href="https://atleticodesanluis.mx/jugadores">Plantel</a>
               <a className="dropdown-item" href="https://atleticodesanluis.mx/calendarios">Calendario</a>
               <a className="dropdown-item" href="https://atleticodesanluis.mx/noticias/tag/primer-equipo">Noticias</a>
               <a className="dropdown-item" href="https://atleticodesanluis.mx/calendarios/tabla_general">Estadísticas</a>
               <a className="dropdown-item" href="https://atleticodesanluis.mx/fotogalerias">Galerías</a>
             </div>
           </li>

           <li className="nav-item dropdown">
             <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Femenil
             </a>
             <div className="dropdown-menu" aria-labelledby="navbarDropdown">
               <a className="dropdown-item" href="https://atleticodesanluis.mx/jugadoras">Plantel</a>
               <a className="dropdown-item" href="https://atleticodesanluis.mx/calendarios_femenil/calendario">Calendario</a>
               <a className="dropdown-item" href="https://atleticodesanluis.mx/noticias/tag/femenil">Noticias</a>
               <a className="dropdown-item" href="https://atleticodesanluis.mx/calendarios_femenil/tabla_general/Grita_Mxico_C22_F">Estadísticas</a>
               <a className="dropdown-item" href="https://atleticodesanluis.mx/fotogalerias_femenil">Galerías</a>
             </div>
           </li>

           <li className="nav-item dropdown">
             <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
               Juveniles
             </a>
             <div className="dropdown-menu" aria-labelledby="navbarDropdown">
               <a className="dropdown-item" href="https://atleticodesanluis.mx/contenidos/categorias-juveniles">Categorías</a>
               <a className="dropdown-item" href="https://atleticodesanluis.mx/contenidos/visorias">Visorias</a>
               <a className="dropdown-item" href="https://atleticodesanluis.mx/fotogalerias_juveniles/lista">Galerías</a>
             </div>
           </li>
          
           <li className="nav-item">
             <a className="nav-link" href="https://atleticodesanluis.mx/contenidos/escuelaoficial">ESCUELA</a>
           </li>

           <li className="nav-item">
             <a className="nav-link" href="https://atleticodesanluis.mx/contenidos/boletos">Boletos</a>
           </li>
          
           <li className="nav-item">
             <a className="nav-link" href="https://adsltienda.mx/" target="_blank">Tienda</a>
           </li>
           <li className="nav-item">
             <a className="nav-link" href="https://atleticodesanluis.mx/contenidos/responsabilidad-social">Responsabilidad social</a>
           </li>
          
         </ul>
       </div>
     </nav>
   </div>
</header>
    </StyledComponent>
)